export default __webpack_public_path__ + "static/cl-social-f95fcaea84641ea4349c9d58df2df3f1.jpg";